module.exports = __webpack_public_path__ + "img/wand.6e172d77.svg";